<p-tabView>
  <!-- warehouse stock table -->
  <p-tabPanel class="testFromStepper" [header]="'WAREHOUSE.STOCKLIST' | translate">
    <div class="p-fluid p-formgrid grid">
      <div class="col-12 md:col-12">
        <p-card styleClass="card">
          <ng-template pTemplate="header">
            <p-toolbar>
              <div>
                {{'WAREHOUSE.STOCKLIST' | translate}}
              </div>
              <div>
                <p-button icon="pi pi-download" styleClass="p-button-primary" (click)="downloadCSV()"
                          label="{{'CSV' | translate}}"></p-button>
              </div>
            </p-toolbar>
          </ng-template>
          <!-- styleClass="p-datatable-gridlines" -->
          <p-table #dt1 [value]="itemStocks" dataKey="id" [globalFilterFields]="['itemCode','itemName']"
                   (onRowExpand)="onRowSelect($event)" [loading]="loading" rowExpandMode="single">

            <ng-template pTemplate="caption">
              <div>
                <span class="p-input-icon-left mb-2">
                  <i class="pi pi-search"></i>
                  <input pInputText type="text" #filter (input)="dt1.filterGlobal($event.target.value, 'contains')"
                         placeholder="{{'GENERIC.SEARCH' | translate}}" class="w-full" />
                </span>
              </div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th></th>
                <th pSortableColumn="itemCode">
                  <div class="flex justify-content-between align-items-center">
                    {{'WAREHOUSE.ITEMCODE' | translate}} <p-sortIcon field="itemCode"></p-sortIcon>
                  </div>
                </th>

                <th pSortableColumn="itemName">
                  <div class="flex justify-content-between align-items-center">
                    {{'WAREHOUSE.ITEMNAME' | translate}} <p-sortIcon field="itemName"></p-sortIcon>
                  </div>
                </th>

                <th pSortableColumn="maxAmountOnPallet">
                  <div class="flex justify-content-between align-items-center">
                    {{'WAREHOUSE.MAXAMOUNTPALLET' | translate}} <p-sortIcon field="maxAmountOnPallet"></p-sortIcon>
                  </div>
                </th>

                <th pSortableColumn="totalAmount">
                  <div class="flex justify-content-between align-items-center">
                    {{'WAREHOUSE.TOTALAMOUNT' | translate}} <p-sortIcon field="totalAmount"></p-sortIcon>
                  </div>
                </th>

                <th pSortableColumn="totalPalletsAmount">
                  <div class="flex justify-content-between align-items-center">
                    {{'WAREHOUSE.TOTALPALLETAMOUNT' | translate}} <p-sortIcon field="totalPalletsAmount"></p-sortIcon>
                  </div>
                </th>

              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-itemStock let-expanded="expanded">
              <tr [pSelectableRow]="itemStock">
                <td>
                  <button pTooltip="details"
                          style="background-color: transparent; border: 1px solid #ffffff00; background:none !important; box-shadow:none !important;"
                          pButton [pRowToggler]="itemStock"
                          [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>

                </td>
                <td style="min-width: 12rem;">
                  {{itemStock.itemCode}}
                </td>
                <td style="min-width: 12rem;">
                  {{itemStock.itemName}}
                </td>
                <td class="text-center">
                  {{itemStock.maxAmountOnPallet}}
                </td>
                <td class="text-center">
                  {{itemStock.totalAmount}}
                </td>
                <td class="text-center">
                  {{itemStock.totalPalletsAmount}}
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="4">{{'NOCUSTOMERSFOUNDMESSAGE' | translate}}</td>
              </tr>
            </ng-template>

            <ng-template pTemplate="loadingbody">
              <tr>
                <td colspan="4">{{'FETCHINGCUSTOMERSMESSAGE' | translate}}</td>
              </tr>
            </ng-template>

            <ng-template pTemplate="rowexpansion" let-stock>

              <tr>
                <td colspan="8" style="padding-left: 45px; padding-bottom: 1.5rem;">
                  <p-table [value]="stock.details" dataKey="id">
                    <ng-template pTemplate="header">
              <tr>
                <th>Colli Art</th>
                <th>Antal</th>
                <th>Vare</th>
                <th>Vare kode</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-line>
              <tr>
                <td>{{ line.colliType }}</td>
                <td>{{ line.amountOnPallet }}</td>
                <td>{{ line.itemName }}</td>
                <td>{{ line.itemCode }}</td>
              </tr>
            </ng-template>
          </p-table>

          </td>
          </tr>
          </ng-template>

          </p-table>
        </p-card>
      </div>
    </div>
  </p-tabPanel>

  <!-- Warehouse order table -->
  <p-tabPanel [header]="'ORDERWAREHOUSETAB' | translate">
    <p-card styleClass="card">
      <ng-template pTemplate="header">
        <p-toolbar>
          <div>
            {{'ORDERWAREHOUSETAB' | translate}}
          </div>
        </p-toolbar>
      </ng-template>
      <!-- filter and options row -->
      <div style="padding-bottom: 10px; max-width: 25vw; min-width: 25vw;" class="flex-column">
        <div style="display: flex; flex-direction: row; gap:15px">

          <!-- input SEARCH field -->
          <span class="p-input-icon-left">
            <input pInputText type="text" (input)="orderTable.filterGlobal($event.target.value, 'contains')"
                   placeholder="{{'GENERIC.SEARCH' | translate}}" />
            <i class="pi pi-search"></i>
          </span>
          <p-multiSelect [options]="translatedStatus$ |async" optionLabel="label" [placeholder]="'WAREHOUSE.WAREHOUSEORDRE.FILTERBYSTATUS' | translate" optionValue="guid" [showClear]="true" (onClear)="ClearFilter()" (onChange)="FilterStatusSeleted($event)"></p-multiSelect>

        </div>

        <div style="display: flex; flex-direction: row; gap:15px; align-items: center;">
          <!-- <alice-dateSeletor style="max-width: 41.5%;" IsAllowedHoliyDaySelect="true" [minDate]="minDate" [defualtStartDate]="startDate" (DateChangeEvent)="DateSeltorEvent($event,true)" [AllowWeekdenBooking]="true"></alice-dateSeletor>
          <p>-</p>
          <alice-dateSeletor style="max-width: 41.5%;" IsAllowedHoliyDaySelect="true" [minDate]="minDate" [defualtStartDate]="endDate" (DateChangeEvent)="DateSeltorEvent($event,false)" [AllowWeekdenBooking]="true"></alice-dateSeletor> -->
          <div style="display: flex; flex-direction: row; gap:15px; align-items: center;">
            <p-calendar styleClass="w-full" selectionMode="range" [(ngModel)]="selectedDateRange" [minDate]="minDate" [showIcon]="true" dateFormat="dd-mm-yy" [placeholder]="'GENERIC.PICKDATEINTERVAL' |translate" (onSelect)="DateRangeSelectorEvent($event)"> </p-calendar>
            <button pButton Style="min-width:15px" [disabled]="!selectedDateRange[1]" (click)="PerformSearch()">{{'GENERIC.SEARCH' | translate}}</button>
          </div>

        </div>

      </div>
      <div>
        <button pButton (click)="CreateOrdreModalOpen()" pTooltip="opret ny ordre" class="pi pi-plus icon-hover"></button>
      </div>

      <p-table #orderTable [globalFilterFields]="['orderNumber','direction','refference']" [value]="WarehouseOrder$ | async" dataKey="id" rowExpandMode="single" (sortFunction)="orderSort($event)" [customSort]="true">
        <ng-template pTemplate="header">
          <tr>
            <th></th>
            <th pSortableColumn="orderNumber"> {{'WAREHOUSE.WAREHOUSEORDRE.ORDERNUMBER' | translate}} <p-sortIcon field="orderNumber"></p-sortIcon> </th>
            <th pSortableColumn="refference"> {{'WAREHOUSE.WAREHOUSEORDRE.REFERENCE' | translate}}</th>
            <th pSortableColumn="direction"> {{'WAREHOUSE.WAREHOUSEORDRE.DIRECTION' | translate}} <p-sortIcon field="direction"></p-sortIcon> </th>
            <th pSortableColumn="orderDate"> {{'WAREHOUSE.WAREHOUSEORDRE.ORDERSTATUS' | translate}}</th>
            <th pSortableColumn="deliveryDate"> {{'WAREHOUSE.WAREHOUSEORDRE.deliveryDate' | translate}}</th>
            <th> {{'DATE' | translate}}</th>
          </tr>
        </ng-template>


        <ng-template pTemplate="body" let-orderLine let-expanded="expanded">
          <tr [pSelectableRow]="orderLine">
            <td>
              <button pTooltip="Order linjer"
                      style="background-color: transparent; border: 1px solid #ffffff00; background:none !important; box-shadow:none !important;"
                      pButton [pRowToggler]="orderLine" *ngIf="orderLine.status != 'f83a3b52-7031-4c0b-85b9-dca2303260a5'"
                      [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
            </td>
            <td> {{orderLine.orderNumber}} </td>
            <td>{{orderLine.refference}}</td>
            <td> {{"WAREHOUSE.WAREHOUSEORDRE." + orderLine.direction | translate}} </td>
            <td> {{"WAREHOUSE.WAREHOUSEORDRE."+ orderLine.status | translate}} </td>
            <td *ngIf="orderLine.deliveryDate"> {{orderLine.deliveryDate | date:"dd-MM-yyyy"}} </td>
            <td> {{orderLine.orderDate | date:"dd-MM-yyyy"}} </td>
            <!-- TODO: add infomation about the place to deleveriy and reiptien -->
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4">{{'NOCUSTOMERSFOUNDMESSAGE' | translate}}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="loadingbody">
          <tr>
            <td colspan="4">{{'FETCHINGCUSTOMERSMESSAGE' | translate}}</td>
          </tr>
        </ng-template>

        <!-- expandable -->
        <ng-template pTemplate="rowexpansion" let-order>
          <div style="padding-left: 15%;">
            <h6>{{"DELIVERYINFORMATION" | translate}}:</h6>
            <div>
              <p style="padding-left: 10px;">{{order.deliveryStreet}}, {{order.deliveryZipCode}} {{order.deliveryCity}}
              </p>
              <p style="padding-left: 10px;">{{order.deliveryContactEmail}} - {{order.deliveryContactPerson}}</p>
            </div>
          </div>
          <tr>
            <td colspan="8" style="padding-left: 45px; padding-bottom: 1.5rem;">
              <p-table [value]="order.orderLines" dataKey="id">
                <ng-template pTemplate="header">
          <tr>
            <th>{{"AMOUNTPLL" | translate}}</th>
            <th>{{'WAREHOUSE.WAREHOUSEORDRE.AMOUNT' | translate}}</th>
            <th>{{'WAREHOUSE.WAREHOUSEORDRE.STOCK' | translate}}</th>
            <th>Batch nr</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-line>
          <tr>
            <td>{{ line.amount }}</td>
            <td>{{ line.amountOnPallet }}</td>
            <td>{{ line.itemName }}</td>
            <td>{{ line.batchNo }}</td>
          </tr>
        </ng-template>
      </p-table>

      </td>
      </tr>
      </ng-template>
      <hr>

      </p-table>
    </p-card>
  </p-tabPanel>
</p-tabView>